import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
      // Animate scroll to top quickly (under 1 second)
      const scrollDuration = 500; // ms
      const startY = window.scrollY;
      const startTime = performance.now();

      function animateScroll(now) {
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / scrollDuration, 1);
        const ease = 1 - Math.pow(1 - progress, 3); // easeOutCubic
        window.scrollTo(0, startY * (1 - ease));
        if (progress < 1) {
          requestAnimationFrame(animateScroll);
        }
      }
      if (startY > 0) {
        requestAnimationFrame(animateScroll);
      }
  }, [pathname]);

  return null;
}
